import { firestoreAction } from 'vuexfire'
import {db} from "@/plugins/db";


export default {
    namespace: true,
    state:{
        practices: []
    },
    actions:{
        bindPractice: firestoreAction(({ bindFirestoreRef }, order) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('practices', db.collection('practices').orderBy('order', order))
        }),

        createPractice: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            return db.collection('practices').add(payload).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

    }
}